interface SidebarState {
    collapsed: boolean;
    toggleCollapse: () => void;
    reset: () => void;
}

const defaultState: SidebarState = {
    collapsed: true,
    toggleCollapse: () => {},
    reset: () => {},
};

export const createSidebarSlice = (set: any, get: any, storeApi: any) => {
    return {
        ...defaultState,
        toggleCollapse: () => set((state: SidebarState) => ({ collapsed: !state.collapsed })),
        reset: () => set(defaultState),
    }
}
